import PropTypes from 'prop-types';

import PageBuilder from '../../Core/PageBuilder';
import Link from '../../Core/Link';
import RichText, { fragment } from '../../Core/RichText';
import DigitalProductBlock from '../DigitalProduct/DigitialProductBlock';
import ABMLocator from '../ABMLocator';
import IndividualBlade from '../IndividualBlades';
import ChecklistBanner from '../Banners/ChecklistBanner';

import {
  StyledContainer,
  ContentWrapper,
  SectionWrapper,
  Links,
} from './styles';

const pageTemplate = {
  'app-banner': DigitalProductBlock,
  'abm-pavilion-map': ABMLocator,
  'checklist-banner': ChecklistBanner,
};

const SectionContainer = ({ data, className = '' }) => {
  const {
    elements,
    anchorName,
    component,
    backgroundColor,
    contentAlignment,
    sectionContainerHeading,
    sectionSubheading,
    ctas,
  } = data;

  return (
    <StyledContainer
      backgroundColor={backgroundColor}
      className={`${contentAlignment} ${className || component}`}
      id={anchorName}
    >
      {(sectionContainerHeading || sectionSubheading) && (
        <ContentWrapper className={contentAlignment}>
          {sectionContainerHeading && (
            <RichText document={sectionContainerHeading} />
          )}
          {sectionSubheading && <RichText document={sectionSubheading} />}
        </ContentWrapper>
      )}
      {elements &&
        elements.map((section, index) => (
          <SectionWrapper key={section.id} index={index}>
            <PageBuilder sections={[section]} template={pageTemplate} />
          </SectionWrapper>
        ))}
      {ctas && (
        <Links contentAlignment={contentAlignment}>
          {ctas.map(cta => {
            if (cta.hideFrench === true) return null;
            return cta.internal.type === 'ContentfulBlade' ? (
              <IndividualBlade key={cta.id} data={cta} />
            ) : (
              <Link key={cta.id} data={cta}>
                <RichText document={cta.label} options={fragment} />
              </Link>
            );
          })}
        </Links>
      )}
    </StyledContainer>
  );
};

SectionContainer.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default SectionContainer;
